<template>
    <div class="max-sm:w-full w-full">
        <div class="relative w-full">
            <div class="absolute inset-y-0 left-0 flex items-center w-7 h-10 ml-2 pointer-events-none">
                <Icon class="w-6 h-6" icon="ic:baseline-search" color="#c9c4c4" />
            </div>
            <input type="text" class="hrm_table_search bg-gray-50 border border-gray-300 text-gray-900 text-sm max-sm:w-full rounded-sm
                 focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 dark:bg-gray-700 dark:border-gray-600 
                 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                :placeholder="placeholder" v-model="query" @input="handleInput" autocomplete="off" />
            <div v-if="query" class="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
                @click="clearSearch">
                <Icon icon="basil:cross-solid" style="color: #6f6d6d" class="w-6 h-6" />
            </div>
        </div>
    </div>
</template>
<script>
import { Icon } from '@iconify/vue';
export default {
    name: 'SearchBox',
    props: {
        placeholder: {
            type: String,
            default: 'Search..',
        },
        modelValue: {
            type: String,
            default: '',
        },
    },
    components: {
        Icon
    },
    data() {
        return {
            query: this.modelValue,
        };
    },
    watch: {
        modelValue(newVal) {
            this.query = newVal;
        },
    },
    methods: {
        handleInput() {
            this.$emit('update:modelValue', this.query);
            this.$emit('searchValue', this.query)
        },
        clearSearch() {
            this.query = '';
            this.$emit('update:modelValue', '');
            this.$emit('searchValue', this.query)
        }
    },
};
</script>
<style scoped>
.hrm_table_search {
    background: #292c2f !important;
    border-radius: 4px;
}
</style>
